// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener, removeListeners } from "~/lib/signals";
import ContentFull from "~/content.full";
import { _ } from "~/i18n";
import createMobileAppButtons from "~/ui/mobileappbuttons";
import { CONFIG } from "~/config";
import Canonical from "~/canonical";

const SECTION_INDEXES_ORDER = [
	15, 19, 20, 21, 17, 22, 23, 6, 7, 16,
];

export default function MobilePromo() {
	return class extends ContentFull {
		_sc: Array<string>;

		constructor() {
			super();

			this._contentName = "mobile-promo";
			this._dom = {
				container: node("div", { className: "mobile-promo" }),
			};

			this._sc = [];
			this._sc.push(addListener(this, "width-change-start", "_widthChangeStart"));

			this._buildCloseButton();
		};

		destroy() {
			removeListeners(this._sc);

			this._clear();

			super.destroy();
		};

		getContainer() {
			return this._dom.container;
		}

		activate() {
			if (this.isActive()) {
				return this;
			}

			!this._dom.container.innerHTML && this._build();

			super.activate();

			Mapy.SEO.set(_("mobilePromo.seoTitle"), _("mobilePromo.seoDesc"), _("mobilePromo.seoKeywords"));
			Canonical.set("/mobilepromo");

			this._appendCloseButton();

			return this;
		}

		deactivate() {
			if (!this.isActive()) {
				return this;
			}

			this._removeCloseButton();

			return super.deactivate();
		}

		_widthChangeStart(event) {
			if (event.data.newWidth < 2) {
				this.deactivate();
			}
		}

		setState(state) {
			this["mobilepromo" in state ? "activate" : "deactivate"]();
		}

		getState() {
			return { mobilepromo: 1 };
		}

		_build() {
			console.log("build");
			// uvodni kecy
			const intro = node("div", { className: "intro" });
			intro.innerHTML = "<h1>Mapy.com</h1>"
			+ '<img src="/img/mobile/logo.png" />'
			+ "<h2>" + _("mobilePromo.introLine") + "</h2>";
			this._dom.container.appendChild(intro);

			if (!CONFIG.isMapyczApp) {
				const sticky = node("div", { className: "sticky" });
				const apps = createMobileAppButtons();

				sticky.appendChild(apps);

				this._dom.container.append(sticky);
			}

			const features = node("div", { className: "features" });
			const langTable = [
				{ source: "cs", langs: ["cs", "sk"] },
				{ source: "en", langs: ["en", "de"] }
			];
			let lang;
			const curLang = CONFIG.defaultLang;

			langTable.every(function(i) {
				if (i.langs.indexOf(curLang) != -1) {
					lang = i.source;
				}
				else return true;
			});

			// def. nechame anglictinu
			if (!lang) {
				lang = "en";
			}

			SECTION_INDEXES_ORDER.forEach(i => {
				const section = node("div");

				section.appendChild(node("img", {
					src: `/img/mobile/${i}.png`,
				}));
				section.appendChild(node("h3", {}, _("mobilePromo.newFeaturesHeader" + i)));
				section.appendChild(node("p", {}, _("mobilePromo.newFeaturesDesc" + i)));

				features.appendChild(section);
			});

			this._dom.container.appendChild(features);
		}

		_clear() {
			this._dom.container.innerHTML = "";
		}

		_appendCloseButton() {
			if (!CONFIG.inFrame && !CONFIG.isMapyczApp) {
				var node = Mapy.getComponent("layout").getScrollNode();
				node.parentNode.insertBefore(this._dom.closeButton, node);
			}
		}
	}
};
